import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOut } from "@fortawesome/free-solid-svg-icons";

import { useAuthentication } from "../../services/authentication/authentication.context";
import { SiteHeader } from "../../components/header/header";
import { LoadingIndicator } from "../../components/utils/loader";
import { AppAlert } from "../../components/utils/alert";
import { faEdit, faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { formatImageUrl } from "../../_helpers/route-image";


export const AdminPage = () => {

    const { account, token, logoutUser, deleteUser, isLoading } = useAuthentication();

    const navigateTo = useNavigate();

    const [onAlert, setOnAlert] = useState();

    const handlePromptLogout = () => {
        setOnAlert({
            caption: "Logout",
            message: "Do you wish to sign out?",
            accept: "Sign out",
            reject: "Cancel",
            onAccept: async () => {
                setOnAlert();
                handleLogout();
            },
            onReject: () => setOnAlert()
        })
    }

    const handleClosePrompt = () => {
        setOnAlert({
            caption: "Delete account",
            message: "Do you wish to delete your account? This action is irreversible!",
            accept: "Delete",
            reject: "Cancel",
            onAccept: async () => {
                setOnAlert();
                handleCloseAcount();
            },
            onReject: () => setOnAlert()
        })
    }

    const handleCloseAcount = async () => {
        const resp = await deleteUser(token);
        if (resp?.error) {
            setOnAlert({
                caption: "Error",
                message: resp?.error,
                accept: "Ok",
                onAccept: () => setOnAlert(),
            });
            return;
        }
        localStorage.removeItem('accessToken');

        setOnAlert({
            caption: "Account Deleted",
            message: "Its been a pleasure. We look forward to having you here again.",
            accept: "Ok",
            onAccept: () => setOnAlert(),
        })
        window.location.reload();
    }

    const handleLogout = async () => {
        const resp = await logoutUser(token);
        if (resp?.error) {
            setOnAlert({
                caption: "Error",
                message: resp?.error,
                accept: "Ok",
                onAccept: () => setOnAlert(),
            });
            return;
        }
        localStorage.removeItem('accessToken');
        window.location.reload();
    }

    return (
        <div className="page-body">
            <SiteHeader pageTitle={'Admin'} />
            {isLoading && <LoadingIndicator />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    onAcept={onAlert.onAccept}
                    onReject={onAlert.onReject}
                    onClose={() => setOnAlert()}
                />
            )}
            
            <div className="account-details">
                <div className="avatar-box">
                    <img
                        src={account?.avatar ? formatImageUrl(account?.avatar) : "/logos/avatar.png"}
                        alt="" className="avatar"
                    />
                </div>
                <div className="detail-unit">
                    <span className="detail-caption">Names</span>
                    <span className="detail-data">{account?.names}</span>
                </div>
                <div className="detail-unit">
                    <span className="detail-caption">Email</span>
                    <span className="detail-data">{account?.email}</span>
                </div>
                <div className="admin-actions">
                    <button 
                        className="admin-action-button"
                        onClick={() => window.location.href = "/updateaccount"}
                    >
                        <FontAwesomeIcon icon={faEdit} className="button-icon" />
                        <span>Update account</span>
                    </button>
                    <button
                        className="admin-action-button"
                        onClick={() => handlePromptLogout()}
                    >
                        <FontAwesomeIcon icon={faSignOut} className="button-icon" />
                        <span>Sign out</span>
                    </button>
                    <button
                        className="admin-action-button"
                        onClick={() => handleClosePrompt()}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} className="button-icon" />
                        <span>Close account</span>
                    </button>
                    {account?.role === "admin" && (
                        <button
                            className="admin-action-button"
                            onClick={() => navigateTo("/dashboard")}
                        >
                            Dashboard
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}